// Vibe — product explainer video. Facade embed: on play, swap the poster for the
// youtube-nocookie iframe. Horizon-native custom-element pattern (cf. vibe-temperature-range).
class VibeProductVideo extends HTMLElement {
  connectedCallback() {
    this.stage = this.querySelector('[data-vibe-film-stage]');
    const btn = this.querySelector('[data-vibe-film-play]');
    if (btn) btn.addEventListener('click', () => this.play(), { once: true });
  }

  play() {
    const url = this.getAttribute('data-embed');
    if (!url || !this.stage) return;
    const frame = document.createElement('iframe');
    frame.style.cssText = 'position:absolute;inset:0;width:100%;height:100%;border:0;';
    frame.setAttribute('allow', 'autoplay; encrypted-media; picture-in-picture; fullscreen');
    frame.setAttribute('allowfullscreen', '');
    const title = this.querySelector('.vibe-film__title');
    frame.setAttribute('title', (title && title.textContent ? title.textContent : 'Product video').trim());
    frame.src = url;
    this.stage.replaceChildren(frame);
  }
}

if (!customElements.get('vibe-product-video')) {
  customElements.define('vibe-product-video', VibeProductVideo);
}
